var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component tip",style:(_vm.tipStyle)},[(_vm.defaultConfig.hasIcon)?_c('i',{class:_vm.defaultConfig.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }